var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0526 4.88889V7.04222C20.6116 7.37278 21 7.96778 21 8.66667V14.3333C21 15.0322 20.6116 15.6272 20.0526 15.9578V18.1111C20.0526 19.15 19.2 20 18.1579 20H4.89474C3.84316 20 3 19.15 3 18.1111V4.88889C3 3.85 3.84316 3 4.89474 3H18.1579C19.2 3 20.0526 3.85 20.0526 4.88889ZM12.4737 14.3333H19.1053V8.66667H12.4737V14.3333ZM4.89474 18.1111V4.88889H18.1579V6.77778H12.4737C11.4316 6.77778 10.5789 7.62778 10.5789 8.66667V14.3333C10.5789 15.3722 11.4316 16.2222 12.4737 16.2222H18.1579V18.1111H4.89474ZM15.3158 12.9167C16.1006 12.9167 16.7368 12.2824 16.7368 11.5C16.7368 10.7176 16.1006 10.0833 15.3158 10.0833C14.531 10.0833 13.8947 10.7176 13.8947 11.5C13.8947 12.2824 14.531 12.9167 15.3158 12.9167Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.bf1277ed8bfd995f1c9b3e2e34622f39.svg";
export { ForwardRef as ReactComponent };